import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable()
export class SeatPlanHelper {

    constructor(private sanitizer: DomSanitizer) { }

    getArtifactStyle(contingents: any, placementTypeId: any, sold: any, contingentId: any, reservationHexColor: any, accessToContingent: any, priceCategoryColor: string | null = null): any {

        if (placementTypeId != 1) return this.sanitizer.bypassSecurityTrustStyle('');

        let style = ''; 
       
        const inReservation: boolean = (reservationHexColor && reservationHexColor !== null);
        const contingent = contingentId ? contingents.find((c: any) => c.Id === contingentId) : null;
        const inContingent = contingent != null;
        const contingentColor = contingent?.HexColor ?? null;

        const statusColor = inReservation ? reservationHexColor : sold ? 'rgba(183,38,55,1)' : (inContingent && !accessToContingent) ? 'rgba(140,140,140,1)' : 'rgba(126, 181,78)';

        if (priceCategoryColor && !sold && !inReservation) {
          if (inContingent && accessToContingent) {
            style = `background: linear-gradient(138deg, ${contingentColor} 0%, ${contingentColor} 34%,  ${priceCategoryColor} 35%, ${priceCategoryColor}  100%);`;
          } else {
            style = `background: ${priceCategoryColor};`;
          }
        } else {
          if (inContingent && (accessToContingent || inReservation)) {
            style = `background: linear-gradient(138deg, ${contingentColor} 0%, ${contingentColor} 34%,  ${statusColor} 35%, ${statusColor}  100%);`; 
          } else {
            style = 'background: ' + statusColor + ';';
          }
        }
      
        return this.sanitizer.bypassSecurityTrustStyle(style);  
      }
    }